import { render, staticRenderFns } from "./ForgeAPI.vue?vue&type=template&id=8645ad08&"
import script from "./ForgeAPI.vue?vue&type=script&lang=js&"
export * from "./ForgeAPI.vue?vue&type=script&lang=js&"
import style0 from "./ForgeAPI.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports